








































































































import { Prop, Component, Vue } from "vue-property-decorator";
import ID from "@abaco/web-components/src/ID";
import { BPopover } from "bootstrap-vue";
import { i18n } from "../i18n";

@Component({
    components: {
        BPopover
    },
    directives: {
        focus: {
            inserted: function(el, binding) {
                if (binding.value) {
                    el.focus();
                }
            }
        }
    }
})
export default class HelperInfoButton extends Vue {
    @Prop({ type: Boolean }) value!: boolean;
    @Prop() title!: string | null;
    @Prop({ type: String, default: "leftbottom" }) placement!: string;
    @Prop({ type: String, default: "click blur" }) triggers!: string;
    // @Prop({ type: String, default: "click" }) triggers!: string;
    @Prop({ type: Boolean }) hasMultipleSections!: boolean;
    @Prop() infoVideoUrl!: string | null;
    @Prop() infoPdfUrl!: string | null;

    private helperId = ID.next();

    private get showHelper() {
        return this.value;
    }
    private set showHelper(val: boolean) {
        this.$emit("input", val);
    }

    private closePopover() {
        this.showHelper = false;
        // remove focus from button
        (this.$refs.element as HTMLElement).blur();
    }

    private openVideo() {
        if (this.infoVideoUrl) {
            window.open(this.infoVideoUrl, "_blank");
        }
    }
    private openPdf() {
        if (this.infoPdfUrl) {
            window.open(this.infoPdfUrl, "_blank");
        }
    }
}
